import vtkArrowSource from './ArrowSource';
import vtkCircleSource from './CircleSource';
import vtkConcentricCylinderSource from './ConcentricCylinderSource';
import vtkConeSource from './ConeSource';
import vtkCubeSource from './CubeSource';
import vtkCursor3D from './Cursor3D';
import vtkCylinderSource from './CylinderSource';
import vtkDiskSource from './DiskSource';
import vtkImageGridSource from './ImageGridSource';
import vtkLineSource from './LineSource';
import vtkPlaneSource from './PlaneSource';
import vtkPointSource from './PointSource';
import vtkRTAnalyticSource from './RTAnalyticSource';
import vtkSLICSource from './SLICSource';
import vtkSphereSource from './SphereSource';

export default {
  vtkArrowSource,
  vtkCircleSource,
  vtkConcentricCylinderSource,
  vtkConeSource,
  vtkCubeSource,
  vtkCursor3D,
  vtkCylinderSource,
  vtkDiskSource,
  vtkImageGridSource,
  vtkLineSource,
  vtkPlaneSource,
  vtkPointSource,
  vtkRTAnalyticSource,
  vtkSLICSource,
  vtkSphereSource,
};
